<i [class]="clickable() ? 'cursor-pointer' : ''" [ngClass]="classes()" [ngStyle]="styles()"></i>
